

export function myPostGoodUserListGet(postId, page, callback) {
	return {
    type: 'MY_POST_GOOD_USER_LIST_GET',
		payload: {
			postId: postId,
			page: page,
		},
		callback: callback,
	}
}

export function myPostGoodUserListInit() {
	return {
    type: 'MY_POST_GOOD_USER_LIST_INIT',
	}
}

export function myPostGoodUserScrollposSet(scrollpos) {
	return {
    type: 'MY_POST_GOOD_USER_LIST_SCROLLPOS_SET',
    payload: {
			scrollpos: scrollpos,
		},
	}
}
